import { api } from '../../../lib/api'

export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_FAILED = 'GET_NOTIFICATIONS_FAILED'

export const getNotifications = () => {
  return function (dispatch) {
    dispatch({
      type: GET_NOTIFICATIONS_REQUEST
    })
    api.getNotifications().then(getNotificationsResponse => {
      dispatch({
        type: GET_NOTIFICATIONS_SUCCESS,
        payload: getNotificationsResponse
      })
    }).catch(error => {
      dispatch({
        type: GET_NOTIFICATIONS_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/notification/get-notifications.js